(function () {
    const checkoutSelector = '.wp-block-woocommerce-checkout';
    const toggleSelector = '.wc-block-components-checkout-order-summary__title';
    const openClass = 'is-open';

    const checkoutEl = document.querySelector(checkoutSelector);
    if (!checkoutEl) return;

    const updateOrderSummaryPrices = () => {
        const items = document.querySelectorAll('.wc-block-components-order-summary-item');

        items.forEach(item => {
            const quantitySpan = item.querySelector('.wc-block-components-order-summary-item__quantity span');
            const priceEl = item.querySelector('.wc-block-components-order-summary-item__individual-price');

            if (quantitySpan && priceEl && !priceEl.dataset.modified) {
                const quantity = quantitySpan.textContent.trim();
                priceEl.textContent = `${quantity} × ${priceEl.textContent.trim()}`;
                priceEl.dataset.modified = 'true';
            }
        });
    };

    const tryUpdate = () => {
        updateOrderSummaryPrices();
        replaceOrderSummaryHeading();
        setTimeout(() => {
            updateOrderSummaryPrices();
            replaceOrderSummaryHeading();
        }, 300);
    };

    const openOrderSummary = () => {
        const toggleEl = document.querySelector(toggleSelector);
        const isOpen = toggleEl && toggleEl.classList.contains(openClass);

        if (window.innerWidth <= 1050 && toggleEl && !isOpen) {
            toggleEl.click();
            setTimeout(tryUpdate, 300);
        } else if (!toggleEl) {
            setTimeout(openOrderSummary, 200);
        } else {
            tryUpdate();
        }
    };

    const replaceOrderSummaryHeading = () => {
        const headingP = document.querySelector('.wc-block-components-checkout-order-summary__title-text');

        if (headingP && headingP.tagName.toLowerCase() === 'p') {
            const h2 = document.createElement('h2');
            h2.className = headingP.className;
            h2.textContent = headingP.textContent;
            headingP.replaceWith(h2);
        }
    };

    if (checkoutEl.classList.contains('is-loading')) {
        const observer = new MutationObserver(() => {
            if (!checkoutEl.classList.contains('is-loading')) {
                observer.disconnect();
                openOrderSummary();
            }
        });

        observer.observe(checkoutEl, { attributes: true, attributeFilter: ['class'] });
    } else {
        openOrderSummary();
    }
})();
